import { Link } from "react-router-dom";

export default function AboutCTA() {
  return (
    <section className="bg-white py-20 md:py-24">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <div className="overflow-hidden rounded-3xl bg-green-600 px-6 py-14 text-center md:px-12 md:py-16">
          <h2 className="text-3xl font-bold text-white md:text-4xl">
            مستعد لبدء رحلة تدوير أفضل؟
          </h2>

          <p className="mx-auto mt-5 max-w-2xl leading-8 text-green-50">
            تواصل معنا اليوم لمعرفة كيف يمكننا مساعدتك في إدارة المواد
            القابلة لإعادة التدوير بطريقة أكثر كفاءة.
          </p>

          <Link
            to="/contact"
            className="mt-8 inline-flex items-center justify-center rounded-xl bg-white px-7 py-3.5 font-semibold text-green-700 transition hover:bg-gray-100"
          >
            تواصل معنا
          </Link>
        </div>
      </div>
    </section>
  );
}